import { useReduxState } from 'hooks';

interface Props {
  align?: React.CSSProperties['textAlign'];
  padding?: number;
  text: string;
}

const BoxEmpty = ({ align = 'left', padding, text }: Props) => {
  const { theme } = useReduxState();

  return (
    <div
      className="empty"
      style={{
        textAlign: align,
        padding: padding !== undefined ? padding : 15
      }}
    >
      {text}

      <style jsx>{`
        .empty {
          color: ${theme.textColorLighter};
          font-size: 1.5rem;
        }
      `}</style>
    </div>
  );
};

export default BoxEmpty;
